

import { IMasterDetailProps } from '../../../../Types/MasterDetailTypes';

const MdInline: React.FC<IMasterDetailProps> = ({ master, detail }) => {
  const Master = master.comp;
  const Detail = detail.comp;

  // TODO: MdInline har varit trasig länge, det finns kod som utgår från att det inte går att välja någon detalj
  // i t.ex. AssociationList där MdInline väljs om man inte ska kunna välja någon detalj.
  // const [selectedDetail, setSelectedDetail] = useState<TSelectedDetail>(null);
  const selectedDetail = null;
  // undefined är egentligen fel, men BusinessDataList hanterar det genom att disabla val av detalj och det krävs för att den inte
  // ska se klickbar ut.
  const setSelectedDetail = undefined as any;

  return (
    <Master
      selectDetail={setSelectedDetail}
      inlineDetail={<Detail id={selectedDetail} />}
      selectedDetail={selectedDetail}
    />
  );
};

export default MdInline;
